/**
 * 정책 관리 > 분석 > 정책 위반 탐지 Store
 *
 * @since 2018-05-21
 * @author devp021
 */

import { formatDate } from '~/utils/date'
import { pcDownloadFile } from '~/utils/files'

const apiUrl = {
  // 공통 설정 시작
  fwAnalysisConfig: '/api/pm/fw-analysis-config', // 공통 설정 조회/적용 API
  // 공통 설정 종료
  // 탐지 내역 시작
  fwComplianceDetectConf: '/api/pm/fw-compliance-detect-conf',
  fwComplianceDetect: '/api/pm/fw-compliance-detect', // 위반 정책 탐지 API
  fwComplianceDetectList: '/api/pm/fw-compliance-detect-list', // 위반 정책 탐지 목록 API
  fwComplianceDetectDetail: '/api/pm/fw-compliance-detect-detail', // 위반 정책 탐지 상세 팝업 API
  fwComplianceDetectDownload: '/api/pm/fw-compliance-detect-download', // 위반 정책 탐지 목록 엑셀 저장 API
  fwRuleDetail: '/api/pm/fw-rule-detail', // 정책 상세 정보 조회 API
  banNet: '/api/pm/ban-net' // 금지네트워크 조회 API
  // 탐지 내역 종료
}

// Default State
const getDefaultState = () => {
  return {
    // 공통 설정 시작
    fwAnalysisConfigList: [], // 공통 설정 목록
    alarmYn: {changeAlarmYn: '', expireAlarmYn: '', collectTime: ''}, // 좌측같은 객체가 아닌 단일로 지정하면 퀘이사(예. q-toggle) 참조하는 곳에서 changeAlarmYn, expireAlarmYn는 에러가 난다.
    // 공통 설정 종료
    // 탐지 내역 시작
    fwRuleDetailList: [{fw_rule_id_num: '', fw_rule_uname: '', fw_rule_seq: '', fw_rule_use_yn: '', fw_rule_action_type: '', fw_rule_bidir_yn: '', fw_rule_desc: '', from_objs: [], user_objs: [], to_objs: [], srv_objs: [], app_objs: [], time_obj_set: []}],
    deviceIdList: [],
    ruleComplianceDetectList: [],
    ruleComplianceDetectSubList2: [],
    ruleComplianceDetectSubList3: [],
    firewallRuleGroupList: [],
    firewallRuleGroupId: '',
    // 탐지 내역 종료
    // 금지 네트워크 팝업 시작
    banNetworkList: [],
    banNetworkList2: [],
    banNetworkDetailList: [],
    banNetworkId: '',
    banNetId: '',
    fwGrpId: '',
    toggle: {anyRule: 0, expiredRule: 0},
    // 금지 네트워크 팝업 종료
    confDataList: []
  }
}

export const state = () => getDefaultState()

export const mutations = {
  // State 전체 초기화
  releaseAllState (state) {
    // Object.assign(state, getDefaultState())
    const defaultState = getDefaultState()
    _.forEach(defaultState, (v, k) => {
      state[k] = v
    })
  },

  // 공통 설정 시작
  // 공통 설정 목록 설정
  setFwAnalysisConfigList (state, data) {
    state.fwAnalysisConfigList = data

    for (let i = 0; i < state.fwAnalysisConfigList.length; i++) {
      if (state.fwAnalysisConfigList[i].key === 'fw.analysis.change.alarm_yn') {
        state.alarmYn.changeAlarmYn = state.fwAnalysisConfigList[i].val
      }

      if (state.fwAnalysisConfigList[i].key === 'fw.analysis.expire.alarm_yn') {
        state.alarmYn.expireAlarmYn = state.fwAnalysisConfigList[i].val
      }

      if (state.fwAnalysisConfigList[i].key === 'fw.analysis.collect-time') {
        const collectTimeList = state.fwAnalysisConfigList[i].val.split(':')
        const collectTimeHH = collectTimeList[0]
        const collectTimeMm = collectTimeList[1]
        const collectTimeSs = collectTimeList[2]

        const d = new Date()
        state.alarmYn.collectTime = new Date(d.getFullYear(), d.getMonth(), d.getDay(), collectTimeHH, collectTimeMm, collectTimeSs)
      }
    }
  },
  // 공통 설정 시간 형태 설정
  parseCollectTimeData (state, data) {
    state.alarmYn.collectTime = formatDate(data, 'HH:mm:00')
  },
  // 공통 설정 종료

  clearRuleComplianceDetectList (state) {
    state.ruleComplianceDetectList = []
  },
  // 탐지 내역 시작
  setRuleComplianceDetectList (state, data) {
    state.ruleComplianceDetectList = data
  },
  // 미사용
  // setRuleComplianceDetectSubList2  (state, data) {
  //   state.ruleComplianceDetectSubList2 = data
  // },
  clearRuleComplianceDetectSubList3  (state) {
    state.ruleComplianceDetectSubList3 = []
  },
  setRuleComplianceDetectSubList3  (state, data) {
    state.ruleComplianceDetectSubList3 = data
  },
  clearFwRuleDetailList (state) {
    state.fwRuleDetailList = []
  },
  setFwRuleDetailList (state, data) {
    state.fwRuleDetailList = data
  },
  setBanNetworkList (state, data) {
    state.banNetworkList = data
  },
  clearBanNetworkDetailList (state) {
    state.banNetworkDetailList = []
  },
  setBanNetworkDetailList (state, data) {
    state.banNetworkDetailList = _.cloneDeep(data)
    state.banNetworkDetailList[0].policy_mng_ban_net_src = (data[0].policy_mng_ban_net_src_type < 4)
      ? [{addressType: _.cloneDeep(data[0].policy_mng_ban_net_src_type)}]
      : _.map(state.banNetworkDetailList[0].policy_mng_ban_net_src, (item) => {
        item.addressType = _.cloneDeep(data[0].policy_mng_ban_net_src_type)
        return item
      })
    state.banNetworkDetailList[0].policy_mng_ban_net_dst = (data[0].policy_mng_ban_net_dst_type < 4)
      ? [{addressType: _.cloneDeep(data[0].policy_mng_ban_net_dst_type)}]
      : _.map(state.banNetworkDetailList[0].policy_mng_ban_net_dst, (item) => {
        item.addressType = _.cloneDeep(data[0].policy_mng_ban_net_dst_type)
        return item
      })
  },
  setDeviceIdList (state, data) {
    state.deviceIdList = data
  },
  setBanNetworkId (state, data) {
    state.banNetworkId = data
  },
  clearFirewallRuleGroupList (state) {
    state.firewallRuleGroupList = []
  },
  setFirewallRuleGroupList (state, data) {
    const tempData = _.cloneDeep(data)
    for (const key of tempData) {
      if (key.from_objs.length < 1) {
        key.from_objs.push(
          {
            addr_obj_uname: 'ANY'
          }
        )
      }
      if (key.user_objs.length < 1) {
        key.user_objs.push(
          {
            user_obj_uname: 'ANY'
          }
        )
      }
      if (key.to_objs.length < 1) {
        key.to_objs.push(
          {
            addr_obj_uname: 'ANY'
          }
        )
      }
      if (key.srv_objs.length < 1) {
        key.srv_objs.push(
          {
            srv_obj_uname: 'ANY'
          }
        )
      }
      if (key.app_objs.length < 1) {
        key.app_objs.push(
          {
            app_obj_uname: 'ANY'
          }
        )
      }
      if (key.time_obj_set.length < 1) {
        key.time_obj_set.push(
          {
            time_obj_uname: 'ANY'
          }
        )
      }
    }
    state.firewallRuleGroupList = tempData
  },
  setBanNetId (state, data) {
    state.banNetId = data
  },
  setFwGrpId (state, data) {
    state.fwGrpId = data
  },
  clearToggleData (state) {
    state.toggle = {
      anyRule: 0, expiredRule: 0
    }
  },
  setToggleData (state, data) {
    if (data.anyRule !== undefined) {
      state.toggle.anyRule = data.anyRule
    }
    if (data.expiredRule !== undefined) {
      state.toggle.expiredRule = data.expiredRule
    }
  },
  clearConfDataList (state) {
    state.confDataList = []
  },
  setConfDataList (state, data) {
    state.confDataList = data
  }
}

export const actions = {
  // 공통 설정 시작
  // 공통 설정 목록 조회
  async getFwAnalysisConfigListAxios ({commit}) {
    const res = {
      code: 'ok',
      result: {}
    }
    try {
      res.result = await this.$axios.$get(apiUrl.fwAnalysisConfig)
      commit('setFwAnalysisConfigList', res.result)
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 공통 설정 목록 적용
  async applyFwAnalysisConfigListAxios ({state}) {
    const alarmYn =
      {
        list:
          [
            {
              key: 'fw.analysis.change.alarm_yn',
              val: state.alarmYn.changeAlarmYn
            },
            {
              key: 'fw.analysis.expire.alarm_yn',
              val: state.alarmYn.expireAlarmYn
            },
            {
              key: 'fw.analysis.collect-time',
              val: state.alarmYn.collectTime
            }
          ]
      }

    const headers = { headers: { 'Content-Type': 'application/json' } }
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$put(apiUrl.fwAnalysisConfig, alarmYn, headers)
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 공통 설정 종료
  async getRuleSaveAxios ({state}, ruleIdJson) {
    let bRet = false
    try {
      const {data, fileName} = await this.$axios.$file(apiUrl.fwComplianceDetectDownload + '/' + ruleIdJson.banNetId + '/' + ruleIdJson.fwGrpId, {
        responseType: 'blob',
        method: 'post',
        successAlert: false
      })
      const nameData = fileName.replace('UTF-8\'\'', '')
      pcDownloadFile(data, nameData)
      bRet = true
    } catch (e) {
      bRet = false
    }
    return bRet
  },
  async getDetectList ({commit}) {
    let res = {
      code: 'ok',
      result: {
        msg: ''
      }
    }
    try {
      res = await this.$axios.$get(apiUrl.fwComplianceDetectConf, null, {successAlert: false})
      if (res.code.toLowerCase() === 'ok') {
        commit('setConfDataList', res.result)
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 정책 위반 탐지 목록 조회
  async getRuleComplianceDetectList ({commit, state}, data) {
    let res = {
      code: 'ok',
      result: {
        msg: ''
      }
    }
    let netId = ''
    if (data !== undefined) {
      netId = data
    }
    const param = {
      device_id_list: '[' + state.deviceIdList + ']',
      policy_mng_ban_net_id_list: '[' + netId + ']',
      show_all_any_rule: state.toggle.anyRule,
      show_expired_rule: state.toggle.expiredRule
    }
    try {
      res = await this.$axios.$post(apiUrl.fwComplianceDetect, param, {successAlert: false})
      if (res.code.toLowerCase() === 'ok') {
        commit('setRuleComplianceDetectList', res.result)
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 정책 위반 탐지 하위 목록 조회 (depth 2) - (미사용)
  // async getRuleComplianceDetectSubList2 ({commit, state}, node) {
  //   const res = {code: 'ok'}
  //   try {
  //     const param = {
  //       device_id_list: '[' + state.deviceIdList + ']',
  //       show_all_any_rule: state.toggle.anyRule,
  //       show_expired_rule: state.toggle.expiredRule
  //     }
  //     const {code, result} = await this.$axios.$post(apiUrl.fwComplianceDetectList + '/' + node.fwGrpId + '/' + '0', param, {successAlert: false})
  //     if (code.toLowerCase() === 'ok') {
  //       commit('setRuleComplianceDetectSubList2', result)
  //       res.reason = 'SUCCESS'
  //     } else {
  //       res.reason = 'FAIL'
  //     }
  //     return res
  //   } catch (e) {
  //     res.code = 'nok'
  //     res.reason = e.message
  //     return res
  //   }
  // },
  // 정책 위반 탐지 하위 목록 조회 (depth 3)
  async getRuleComplianceDetectSubList3 ({commit, state}, node) {
    let res = {
      code: 'ok',
      result: {
        msg: ''
      }
    }
    const param = {
      device_id_list: '[' + state.deviceIdList + ']',
      show_all_any_rule: state.toggle.anyRule,
      show_expired_rule: state.toggle.expiredRule
    }
    try {
      res = await this.$axios.$post(apiUrl.fwComplianceDetectList + '/' + node.banNetId + '/' + node.fwGrpId, param, {successAlert: false})
      if (res.code.toLowerCase() === 'ok') {
        commit('setRuleComplianceDetectSubList3', res.result)
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 정책 상세 정보 목록 조회
  async getFwRuleDetailList ({commit, state}, node) {
    const res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(apiUrl.fwRuleDetail + '/' + node.fwRuleId, {}, {successAlert: false})
      if (code.toLowerCase() === 'ok') {
        commit('setFwRuleDetailList', result)
        res.reason = 'SUCCESS'
      } else {
        res.reason = 'FAIL'
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  // 금지 네트워크 전체 목록 조회
  async getBanNetworkList ({commit}) {
    const res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$get(apiUrl.banNet + '/' + '0')
      if (code.toLowerCase() === 'ok') {
        commit('setBanNetworkList', result)
        res.reason = 'SUCCESS'
      } else {
        res.reason = 'FAIL'
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  // 금지 네트워크 상세 목록 조회
  async getBanNetworkDetailList ({commit, state}, banNetworkId) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(apiUrl.banNet + '/' + banNetworkId)
      if (res.code.toLowerCase() === 'ok') {
        commit('setBanNetworkDetailList', res.result)
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 방화벽 정책 그룹 목록 조회
  async getFirewallRuleGroupList ({commit, state}) {
    let res = {
      code: 'ok',
      result: {
        msg: ''
      }
    }
    state.firewallRuleGroupList = []
    const param = {
      device_id_list: '[' + state.deviceIdList + ']',
      show_all_any_rule: state.toggle.anyRule,
      show_expired_rule: state.toggle.expiredRule
    }
    try {
      const result = await this.$axios.$post(apiUrl.fwComplianceDetectDetail + '/' + state.banNetId + '/' + state.fwGrpId, param, {successAlert: false})

      if (result.code.toLowerCase() === 'ok') {
        res.code = result.code
        commit('setFirewallRuleGroupList', result.result)
      } else {
        res = result
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  }
}

export const getters = {}
export const strict = false
